import * as THREE from 'three';
import { sceneUnitsFromMm } from '../../utils/scaler';
import Placement3d from '../../model/Placement3d';

// Small square outline shown before the first click of the Rectangle tool, with one of its own
// corners sitting exactly on the cursor (rather than centered on it) — signals "this click sets a
// corner." Oriented the same way the real first-click placement will be (refDirection = local X,
// normal = local Z), reusing Placement3d.getRotationQuaternion() rather than re-deriving the basis.
export default class RectangleCornerHintHelper {
    #square: THREE.LineLoop;

    constructor() {
        const size = sceneUnitsFromMm(150);
        const points = [
            new THREE.Vector3(0, 0, 0),
            new THREE.Vector3(size, 0, 0),
            new THREE.Vector3(size, size, 0),
            new THREE.Vector3(0, size, 0),
        ];
        const geometry = new THREE.BufferGeometry().setFromPoints(points);
        const material = new THREE.LineBasicMaterial({ color: 0x00FF00 });
        this.#square = new THREE.LineLoop(geometry, material);
        this.#square.visible = false;
        this.#square.name = "RectangleCornerHint";
    }

    addToScene(scene: THREE.Scene) {
        scene.add(this.#square);
    }

    update(point: THREE.Vector3, normal: THREE.Vector3, refDirection: THREE.Vector3) {
        this.#square.position.copy(point);
        const placement = new Placement3d(point, refDirection, normal);
        this.#square.quaternion.copy(placement.getRotationQuaternion());
    }

    show() {
        this.#square.visible = true;
    }

    hide() {
        this.#square.visible = false;
    }

    dispose() {
        if (this.#square.parent) {
            this.#square.parent.remove(this.#square);
        }
        this.#square.geometry.dispose();
        (this.#square.material as THREE.Material).dispose();
    }
}
